// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2W0uJ","content":"styles_content__2z9SS","row":"styles_row__18xlS","footer":"styles_footer__UmrsO","phraseLength":"styles_phraseLength__2YaDg"};